import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./services/interceptorRequest";
import "./services/interceptorResponse";

ReactDOM.render(<App />, document.getElementById("root"));
